import React, {
  useState,
  useEffect
} from 'react';

import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  IconButton,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableFooter,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Avatar,
  Button,
} from '@material-ui/core';

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import localization from '../../../utils/localizations';
import {
  History,
  Document,
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  secondPanel: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  pageTitle: {
    marginTop: 10,
    marginBottom: 10,
  },
}));


function DocumentUploadHistory(props: {history: History[]}) {
  const classes = useStyles();
  const history = props.history;

  const [showOlderHistory, setShowOlderHistory] = useState(false);

  const reversedHistory = Object.assign([], history).reverse();

  return (
    <Paper className={classes.secondPanel}>
      <Typography variant="h5" className={classes.pageTitle}>{localization.documentUploadHistory}</Typography>
      <Divider />
      
      <TableContainer>
        <Table aria-label={localization.documentUploadHistory}>
          <TableHead>
            <TableRow>
              <TableCell>{localization.date}</TableCell>
              <TableCell>{localization.type}</TableCell>
              <TableCell>{localization.file}</TableCell>
              <TableCell>{localization.similarity}</TableCell>
              <TableCell>{localization.title}</TableCell>
              <TableCell>{localization.comments}</TableCell>
              <TableCell align="right">{localization.status}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history && reversedHistory.map((historyItem: History, i: number) => {
                if (!showOlderHistory && i > 0) return;

                return historyItem.documents.map((doc: Document, j: number) => {
                  return (
                    <TableRow key={`doc-row-${i}-${j}`}>
                      <TableCell>{moment(doc.created_at).format("Do MMMM YYYY, h:mm:ss a")}</TableCell>
                      <TableCell>{(localization as any)[doc.kind] ? (localization as any)[doc.kind] : doc.kind}</TableCell>
                      <TableCell>
                        <IconButton aria-label="download" size="small" title={doc.file_name} href={doc.file} target="_blank"><CloudDownloadIcon /></IconButton>
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>{historyItem.title ? historyItem.title : '-'}</TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">{(localization as any)[historyItem.status] ? (localization as any)[historyItem.status] : historyItem.status }</TableCell>
                    </TableRow>
                  );
                })
              })
            }
          </TableBody>
          <TableFooter>
            {!showOlderHistory && history && history.length &&
              <TableRow>
                <Button
                  onClick={() => setShowOlderHistory(true)}
                >{localization.showOlderHistory}</Button>
              </TableRow>
            }
            {showOlderHistory && history && history.length &&
              <TableRow>
                <Button
                  onClick={() => setShowOlderHistory(false)}
                >{localization.hideOlderHistory}</Button>
              </TableRow>
            }
          </TableFooter>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export {DocumentUploadHistory};
